<template>
    <section class="category-audio">
        <div class="container">
            <div class="columns is-multiline">
                <div class="column is-4-desktop is-6-tablet is-12-mobile" v-for="item in categoryList.items" :key="item._id">
                    <transition-group name="list" appear>
                        <MbBox :item="item" :key="item._id" :isFavorite="checkIsFavorite(item._id)"></MbBox>
                    </transition-group>
                </div>
            </div>

            <Pagination 
                v-if="isPagination"
                :type="pageType"
                :name="name"
                :id="pageId"
                :itemsPage="itemsPage"
                :itemsPerPage="itemsPerPage" 
                :itemsTotalCount="totalCount">
            </Pagination>
        </div>
    </section>
</template>

<script>
import axios from "axios";
import Pagination from "../elements/Pagination.vue";
import MbBox from "../boxes/MbBox.vue";
import globalDataLayer from '../../mixins/globalDataLayer';

export default {
    name: "CategoryAudio",
    components: {
        MbBox,
        Pagination
    },
    mixins: [globalDataLayer],
    props: {
        pageId: {
            type: Number,
            required: true,
        },
        pageType: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            CATEGORY_LIST: "/api/krainaabc/video/list?device=www&sort=position,1&id=",
            categoryList: [],
            itemsPerPage: 12
        };
    },
    watch: {
        '$route.path': {
            handler: function() {
                this.getCategoryList()
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        itemsPage() {
            if(this.$route.query.page) {
                return parseInt(this.$route.query.page);
            }
            return 1;
        },
        totalCount() {
            if(this.categoryList && this.categoryList.total_count) {
                return this.categoryList.total_count;
            }
            return false;
        },
        isPagination() {
            if(this.totalCount && this.totalCount > this.itemsPerPage) {
                return true;
            } 
            return false;
        },
        activeSubProfile() {
            return this.$store.getters.getActiveSubProfile;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    methods: {
        getCategoryList() {
            let endpoint = `${this.CATEGORY_LIST}${this.pageId}`;

            if(this.itemsPage) {
                endpoint = endpoint + `&limit=${this.itemsPerPage}&page=${this.itemsPage}`;
            }
            
            axios
                .get(endpoint)
                .then((response) => {
                    if (response.status === 200) {
                        if(response.data.data && response.data.data.items && response.data.data.items.length > 0) {
                            this.categoryList = response.data.data;
                        }
                    } else {
                        this.$store.dispatch("changeModalErrorLoadingState", true);
                        this.$store.dispatch("changeModalBackdrop", true);  
                    }
                })
                .catch(() => {
                    this.$store.dispatch("changeModalErrorLoadingState", true);
                    this.$store.dispatch("changeModalBackdrop", true);  
                });
        },
        checkIsFavorite(id) {
            if(this.activeSubProfile && this.activeSubProfile.favorites && this.activeSubProfile.favorites.length && this.activeSubProfile.favorites.findIndex(el => el === id) !== -1) {
                return true;
            }
            return false;
        }        
    },
    mounted() {
       this.navigationEvent(this.name);

       window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        ); 
    } 
}
</script>
